import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { getFlashMessages, removeMessage } from 'redux-flash'

import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import IconButton from '@material-ui/core/IconButton'
import InfoIcon from '@material-ui/icons/Info'
import ErrorIcon from '@material-ui/icons/Error'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'

import { theme as appTheme } from '../theme'

// Komunikaty redux-flash w panelu - ten sam wygląd co w ankiecie 1.4.0 (isa-surveys, src/components/FlashToasts):
// informacja i sukces: białe tło z ramką w kolorze głównym; błąd: żółte tło z ciemnoamberową ramką; tekst ciemny.
// Zastępuje @bit/…display-flash-toasts 0.0.5 (zielony „success” z palety MUI, „info” na tle koloru głównego).
// Kontrasty WCAG: tekst #0A0A0A 19,8:1 na białym i 12,1:1 na #FFC107 (wymóg 4,5:1); ramka #CB092A 5,81:1
// i ramka #A16207 4,92:1 wobec białej strony (wymóg 3:1 dla elementów nietekstowych).
// Komponent stoi poza <Kit> (ThemeProvider panelu), więc kolor marki bierze wprost z theme.js,
// a nie z motywu MUI (ten dałby domyślny indygo #3f51b5).
const KOLOR_MARKI = appTheme.palette.primary.main
const TEKST = '#0A0A0A'
const TLO_BLEDU = '#FFC107'
const RAMKA_BLEDU = '#A16207'
// SnackbarContent z MUI 4 ma padding 6px 16px; ramkę odejmujemy od paddingu, żeby rozmiar się nie zmienił.
const RAMKA = 2

const useStyles = makeStyles((theme) => ({
  stack: {
    display: 'flex',
    position: 'fixed',
    zIndex: 1400,
    flexDirection: 'column-reverse',
    bottom: '1rem',
    left: '1rem',
  },
  item: {
    position: 'static',
    margin: '0.5rem 0',
    maxWidth: 320,
  },
  info: {
    backgroundColor: theme.palette.common.white,
    color: TEKST,
    border: `${RAMKA}px solid ${KOLOR_MARKI}`,
    padding: `${6 - RAMKA}px ${16 - RAMKA}px`,
  },
  error: {
    backgroundColor: TLO_BLEDU,
    color: TEKST,
    border: `${RAMKA}px solid ${RAMKA_BLEDU}`,
    padding: `${6 - RAMKA}px ${16 - RAMKA}px`,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre-line',
  },
  icon: {
    fontSize: 20,
  },
  leadingIcon: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  infoIcon: {
    color: KOLOR_MARKI,
  },
}))

const ikona = (isError, variant) => {
  if (isError || variant === 'error') return ErrorIcon
  if (variant === 'success') return CheckCircleIcon
  return InfoIcon
}

const FlashToasts = (props) => {
  const classes = useStyles()
  const messages = useSelector(getFlashMessages) || []
  const dispatch = useDispatch()

  return (
    <div className={`${classes.stack} FlashToasts`}>
      {
        messages.map(({ id, message, isError, props: messageProps }) => {
          const variant = messageProps && messageProps.variant
          const blad = Boolean(isError) || variant === 'error'
          const Icon = ikona(isError, variant)
          const messageId = `flash-message-${id}`
          const text = typeof message === 'string' ? message.trim() : message
          const iconClassName = [classes.icon, classes.leadingIcon, !blad && classes.infoIcon].filter(Boolean).join(' ')

          return (
            <Snackbar key={id} open={true} className={classes.item} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
              <SnackbarContent
                className={blad ? classes.error : classes.info}
                role={blad ? 'alert' : 'status'}
                aria-describedby={messageId}
                message={
                  <span id={messageId} className={classes.message}>
                    <Icon className={iconClassName} />
                    {text}
                  </span>
                }
                action={
                  <IconButton aria-label={'Zamknij komunikat'} color={'inherit'} onClick={() => dispatch(removeMessage(id))}>
                    <CloseIcon className={classes.icon} />
                  </IconButton>
                }
              />
            </Snackbar>
          )
        })
      }
    </div>
  )
}

FlashToasts.propTypes = {
  children: PropTypes.node,
}

export default FlashToasts
